/**
 * MotionProvider Component
 * 
 * Wraps the app with LazyMotion to reduce framer-motion bundle size.
 * Uses domAnimation feature set which excludes the heavy layout projection
 * system (~5KB savings), while keeping all animation capabilities.
 * 
 * Note: We don't use strict mode as it would require converting all `motion`
 * components to `m` components throughout the codebase. The bundle savings
 * from LazyMotion are still achieved without strict mode.
 * 
 * @see https://www.framer.com/motion/lazy-motion/
 */

import { LazyMotion, domAnimation } from "framer-motion";
import type { ReactNode } from "react";

interface MotionProviderProps {
  children: ReactNode;
}

export const MotionProvider = ({ children }: MotionProviderProps) => {
  return (
    <LazyMotion features={domAnimation}>
      {children}
    </LazyMotion>
  );
};
